const KycStatus = new Map();

KycStatus.set('CONSENT_PENDING', 8);
KycStatus.set('CONSENT_REJECTED', 9);
KycStatus.set('AUTO_APPROVAL_PENDING', 10);
KycStatus.set('AUTO_APPROVED', 11);
KycStatus.set('MANUAL_APPROVAL_PENDING', 12);
KycStatus.set('MANUAL_APPROVED', 13);
KycStatus.set('MANUAL_REJECTED', 14);
KycStatus.set('DRAFT', 15);
KycStatus.set('DRAFT_INACTIVE', 16);

export default KycStatus;
